import { useState } from 'react'

import { Grid } from '@mui/material'

import { CardTitle, FplDynamicTabs, TabPanelBootstrap, TextInput } from 'components/common'

export type BookingPackageDetailsType = {
  id: string
  quantity: number
  weight: string
  type: string
  collectionAddress: string
  deliveryAddress: string
  length: string
  width: string
  height: string
  reference: string
  details: string
  tabsKey: string
}

interface ISupplierPackageDetailsProps {
  packages: BookingPackageDetailsType[]
}

export const SupplierPackageDetails = (props: ISupplierPackageDetailsProps) => {
  const { packages } = props

  const [tabValue, setTabValue] = useState(0)
  const handleTabChange = (_, newValue) => {
    setTabValue(newValue)
  }
  return (
    <>
      <CardTitle>Package Details</CardTitle>

      <FplDynamicTabs
        tabValue={tabValue}
        fields={packages}
        disabled
        name='package'
        label='Consignment'
        onTabChange={handleTabChange}
        onAddClick={undefined}
      />

      {packages.map((item, index) => (
        <TabPanelBootstrap value={tabValue} index={index} key={item.id}>
          <Grid container spacing={1.5}>
            <Grid item xs={6} md={3}>
              <TextInput label='Quantity' value={item.quantity} readOnly />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextInput label='Type' value={item.type} readOnly />
            </Grid>

            <Grid item xs={6} md={3}>
              <TextInput label='Collection' value={item.collectionAddress} readOnly />
            </Grid>

            <Grid item xs={6} md={3}>
              <TextInput label='Delivery' value={item.deliveryAddress} readOnly />
            </Grid>

            <Grid item xs={6} md={3}>
              <TextInput label='Length' value={item.length} readOnly />
            </Grid>

            <Grid item xs={6} md={3}>
              <TextInput label='Width' value={item.width} readOnly />
            </Grid>

            <Grid item xs={6} md={3}>
              <TextInput label='Height' value={item.height} readOnly />
            </Grid>

            <Grid item xs={6} md={3}>
              <TextInput label='Weight' value={item.weight} readOnly />
            </Grid>

            <Grid item xs={12} sm={6} md={4.5}>
              <TextInput label='Reference' value={item.reference} readOnly />
            </Grid>

            <Grid item xs={12} sm={6} md={7.5}>
              <TextInput label='Details' value={item.details} readOnly />
            </Grid>
          </Grid>
        </TabPanelBootstrap>
      ))}
    </>
  )
}
